import {InitPage} from "../../index";
import axios from "axios";
import {RemoveRenderLine} from "./remove_render_line";
import swal from "sweetalert";

declare var $;
declare var loadItemPath: string;
declare var qualityHoldStatusErrorModalPath: string;
declare var selectMethodArray: string[][];
declare var showErrorDialog;
declare var missing_bom_message;
declare var minusImageUrl;

declare global {
    interface Window {
        mpr: ManufacturingProductionReconciliation;
        removeConsumed: RemoveRenderLine;
    }
}

class ManufacturingProductionReconciliation {
    constructor() {
        console.log(loadItemPath);
        const _this   = this;
        $("#serach-item").on("click", function() {
            let _result = "";
            $("#reloadWhole").click();
            axios.get(loadItemPath,
                      { params: { term: $("#term").val(), term_type: $("input[name='term_type']:checked").val() } } )
                  .then((response) => {
                    response.data.epc_tags.forEach((e, index) => {
                        if( $(`.asset-${e.epc_id}`).length > 0 ) {
                            let msg = `The tag #${e.asset_id} has been marked to be fully consumed, in this same WO. <br><br><br>Thus can't be partially consumed as well<br>`;
                            msg += `Kindly keep the tag apart, refresh the page and scan again.`
                            showErrorDialog(msg);
                            return;
                        }
                        _result = _result + _this.loadResultTemplate(e);
                    });
                    $("#bom-result").html(_result);
                    $("#reloadWhole").click();
                  }).catch((error) =>{
                    console.log(error);
                  });
        });

        $("#search-item-clear").on("click", function() { $("#bom-result").html(""); $("#reloadWhole").click();});
    }

    loadResultTemplate(data) {
        let _template = `
            <tr id='table-data-validate-${data.id}'>
            <td>${data.name}`
        if (data.backflush) {
            _template += ` <small><div class="label label-primary">Backflush</div></small>`
        }
        let qualityHoldStatus = "";
        if (data.quality_hold_status == "Yes") {
            qualityHoldStatus = "<div class='label label-danger'>On Hold</div>";
            $.ajax({
                url: qualityHoldStatusErrorModalPath,
                method: "POST",
                data: { epc_id: data.id }
            }).done((e) => {
                console.log(e);
                this.showSweetAlert('Warning', 'warning', 'Selected Item is NOT an Allowable Substitution. Using this item will trigger an Email Alert to Management!')
            });
        }
        _template += `
            </td>
            <td class="expiration_date"><center>${data.expiration_date}</center></td>
            <td class="lot_number"><center>${data.lot_number}</center></td>
            <td class="asset_id">
                <center>
                    <div>${data.asset_id}</div>
                    ${qualityHoldStatus}
                </center>
            </td>
            <td class="base_unit_of_measure"><center>${data.base_unit_of_measure}</center></td>
            <td class="epc_id__current_units"><center><span id="itemOrigQty-${data.epc_id}">${data.current_units}</span></center></td>
            <td class="consumed_qty"><center><input type="number" name="production_tags[${data.epc_id}][consumed_qty]"
                    id="consumedQty-${data.epc_id}"
                    oninput="reloadWhole()"
                    max=${data.current_units}
                    class="changeQty" data-item-qty="${data.current_units}"
                    data-epc-id="${data.epc_id}"
                    data-item-name="${data.name}"
                    data-item-number="${data.item_number}" required></center></td>
            <td class="item_qty"><center><span id="itemQty-${data.epc_id}">${data.current_units}</span></center></td>
            <td><center>
        `;

        if (!data.is_bom_item) {
            _template = _template + `<select onchange="reloadWhole()" id="substitute_ids-${data.epc_id}" class="component-area-tag p-select-option" name="production_tags[${data.epc_id}][substitute_for]" data-epc-id="${data.epc_id}">`;
            _template = _template + `<option value='nosub'>${missing_bom_message}</option>`;
            selectMethodArray.forEach((e) => {
                _template = _template + `<option value="${e[1]}">${e[0]}</option>`;
            });
            _template = _template + "</select>";
        }

        _template = _template + `</center></td><td><center><a href='#' onclick='window.mpr.saveRow(${data.id})' class='btn btn-primary saveTag'>Save</a></center></td>
        <td>
            <center>
                <img att="remove tag" class="minus-image" data-tag-id="${data.id}" src="${minusImageUrl}" width="5" height="5" onclick="window.removeConsumed.removeManuallyConsumed(${data.id})">
            </center>
        </td>
        </tr>`;

        return _template;
    }

    saveRow(id) {
        const content = `<tr id="table-data-save-${id}">` + $(`#table-data-validate-${id}`).html() + "</tr>";
        const consumedQty = $(`#table-data-validate-${id} .changeQty`).val();
        const componentAreaTag = $(`#table-data-validate-${id} .component-area-tag`).val();
        $("#bom-result-save").append(content);
        $(`#table-data-validate-${id}`).remove();
        $(`#table-data-save-${id} .changeQty`).val(consumedQty);
        $(`#table-data-save-${id} .component-area-tag`).val(componentAreaTag);
        $(`#table-data-save-${id}`).find(".saveTag").remove();
    }

    showSweetAlert(title, type, message) {
        swal({
            title: title,
            text: message,
            icon: type,
            className: 'swal-blue-color-for-ok'
        }).then((response) => {
            if (response) { console.log('response of showSweetAlert:', response); }
        });
    }
}

export function LoadPage() {
    InitPage("production reconciliation", () => {
        const m = new ManufacturingProductionReconciliation();
        window.mpr = m;
        window.removeConsumed = RemoveRenderLine;
    });
}
